<template>
    <main>
    <BookingFlowIndex/>
    </main>
  </template>
  
  <script>
  import BookingFlowIndex from "@/components/NewBooking/index";
  
  export default {
    components: {
        BookingFlowIndex,
    },
  };
  </script>
  
  <style></style>
  